<template>
  <Teleport to="body">
  <section class="AZ-navbar-bottom">
    <div class="container">
      <div class="row row-cols-5 g-2">
        <div class="col">
          <router-link
            to="/"
            class="navbar-bootom--link d-flex flex-column align-items-center justify-content-center gap-2"
            :class="{ active: activeTab === 'home' }"
          >
            <span class="icon-home"></span>
            خانه
            </router-link>
        </div>
        <div class="col">
          <router-link
            to="/credit"
            class="navbar-bootom--link d-flex flex-column align-items-center justify-content-center gap-2"
            :class="{ active: activeTab === 'credit' }"
          >
            <span class="icon-money-recive"></span>
            تسهیلات
          </router-link>
        </div>
        <div class="col">
          <router-link
            to="/staking"
            class="navbar-bootom--link d-flex flex-column align-items-center justify-content-center gap-2"
            :class="{ active: activeTab === 'staking' }"
          >
            <span class="icon-money-change"></span>
            سپرده گذاری
          </router-link>
        </div>
        <div class="col">
          <router-link
            to="/trade"
            class="navbar-bootom--link d-flex flex-column align-items-center justify-content-center gap-2"
            :class="{ active: activeTab === 'trade' }"
          >
            <span class="icon-trade"></span>
            معامله
          </router-link>
        </div>
        <div class="col">
          <router-link
            to="/wallet"
            class="navbar-bootom--link d-flex flex-column align-items-center justify-content-center gap-2"
            :class="{ active: activeTab === 'wallet' }"
          >
            <span class="icon-wallet-minus"></span>
            کیف پول
          </router-link>
        </div>
      </div>
    </div>
  </section>
  </Teleport>
</template>

<script>
export default {
  name: 'BottomNavbar',
  props: {
    activeTab: {
      type: String,
      default: '',
      validator: (value) => {
        return ['home', 'credit', 'staking', 'trade', 'wallet', ''].includes(value);
      }
    }
  }
}
</script>

